module.exports = __webpack_public_path__ + "img/fr.8a75d3c2.svg";